var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"VuePagination",class:_vm.props.theme.wrapper},[_c('nav',{class:_vm.props.theme.nav},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.props.hasRecords),expression:"props.hasRecords"}],staticClass:"topPagination",class:_vm.props.theme.count,domProps:{"innerHTML":_vm._s(_vm.props.count)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }